import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection'
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider'
import MaximizeModal from '../../Components/mumbai/MaximizeModal'
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper'
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection'
import LocationForm from '../../Components/mumbai/LocationForm'
import WhyChoose from '../../Components/mumbai/WhyChoose'
import EngagementModels from '../../Components/hire/EngagementModels'
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm'

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Our dedicated team supports businesses across Chennai with responsive service, trusted expertise, and reliable solutions, ensuring seamless operations, lasting partnerships, and sustainable growth every step of the way.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Mobikode empowers businesses across Chennai with tailored digital solutions for healthcare, finance, education, retail, real estate, logistics, and growing enterprises, driving innovation, efficiency, and sustainable growth.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every Swiss business has unique goals. Mobikode delivers tailored digital solutions that streamline operations, enhance efficiency, and empower sustainable growth with innovation, reliability, and precision.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "Mobikode empowers financial institutions across Chennai to streamline operations, enhance customer experiences, strengthen security, and accelerate sustainable growth through innovative, reliable, and future-ready digital technology solutions.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "Mobikode empowers eCommerce businesses across Chennai with innovative digital solutions that streamline operations, enhance customer experiences, accelerate online growth, and deliver sustainable success in a competitive market.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Chennai's insurance providers modernize operations with secure digital solutions, seamless claims and policy management, enhanced customer experiences, and intelligent automation that drives efficiency, compliance, and sustainable growth.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we empower manufacturing businesses across Chennai with intelligent digital solutions that streamline operations, boost productivity, optimize workflows, and drive sustainable growth through innovation and automation.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "Mobikode empowers Chennai's retail and consumer brands with intelligent digital solutions that enhance customer experiences, streamline operations, boost efficiency, and drive sustainable business growth with confidence.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we empower Chennai's healthcare and life sciences organizations with innovative digital solutions that enhance patient care, streamline operations, and deliver better health outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers Chennai's media and communications businesses with innovative digital solutions that strengthen audience connections, streamline operations, and create engaging brand experiences that inspire lasting customer loyalty.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "Mobikode empowers Chennai's logistics and transportation businesses to streamline operations, optimize supply chains, enhance delivery experiences, and achieve sustainable growth through secure, innovative, and reliable digital solutions.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "Helping Chennai's technology businesses transform ideas into innovative digital solutions with creative expertise, reliable technology, and scalable software that drives efficiency, growth, and long-term business success.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we empower non-profit organizations across Chennai with innovative digital solutions that strengthen community engagement, streamline operations, and maximize their social impact for lasting change.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we empower professional service businesses across Chennai with tailored digital solutions that streamline operations, embrace innovation, enhance client experiences, and drive sustainable business growth with confidence.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "Mobikode helps Chennai's real estate businesses simplify operations, deliver exceptional customer experiences, and build stronger relationships between developers, agents, and property buyers through smart digital solutions.",
        image: "/assets/mumbai/item12.png"
    },

];

function Chennai() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Chennai | ITSM & Workflow Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode offers ServiceNow consulting in Chennai to optimize IT service management, streamline business workflows, integrate enterprise applications, and improve service delivery through scalable technology solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Chennai, ServiceNow Consultant Chennai, ServiceNow ITSM Chennai, ServiceNow Workflow Solutions Chennai, ServiceNow Application Integration Chennai, ServiceNow Workflow Automation Chennai, ServiceNow Implementation Chennai, ServiceNow Managed Services Chennai, ServiceNow Development Chennai, ServiceNow Digital Transformation Chennai"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-chennai"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Chennai | ITSM & Workflow Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Improve service delivery with Mobikode's ServiceNow consulting services in Chennai. Optimize ITSM, automate workflows, integrate business applications, and create more efficient digital processes."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-chennai"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/chennai/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Chennai | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Discover ServiceNow solutions in Chennai for IT service management, workflow automation, application integration, service delivery, and digital transformation with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/chennai/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Chennai" description="Partner with Mobikode’s ServiceNow experts in Chennai to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Chennai.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Chennai
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Empower your business in Chennai with Mobikode's ServiceNow experts to streamline operations, automate workflows, boost productivity, and accelerate sustainable digital growth with confidence.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Chennai.png"}
                text={"At Mobikode, we help businesses across Chennai maximize the value of ServiceNow with tailored consulting and intelligent automation. From seamless implementation and custom development to integrations and ongoing support, our experts simplify complex workflows, improve operational efficiency, enhance user experiences, and deliver scalable digital solutions that empower sustainable business growth and long-term transformation."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we empower businesses across Chennai with tailored ServiceNow solutions, intelligent automation, and expert consulting to streamline operations, boost efficiency, and deliver exceptional digital experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Chennai
